import { render, staticRenderFns } from "./AvatarInitial.vue?vue&type=template&id=3a6caed4&scoped=true"
import script from "./AvatarInitial.vue?vue&type=script&lang=js"
export * from "./AvatarInitial.vue?vue&type=script&lang=js"
import style0 from "./AvatarInitial.vue?vue&type=style&index=0&id=3a6caed4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.21_css-loader@6.11.0_webpack@5.104.1_cssnano@5_665be98a8828166c9882e9000b2a540b/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a6caed4",
  null
  
)

export default component.exports